import firehydrantAPI from 'helpers/firehydrantAPI';
import { createMutationHook, useApiQuery } from 'queries/common';

export const RUNBOOKS = 'RUNBOOKS';
export const useRunbooks = (params = {}, options = {}) => {
  const requestParams = { params: { per_page: 20, ...params } };

  const query = useApiQuery(
    [RUNBOOKS, 'list', params],
    () => firehydrantAPI.get('/runbooks', requestParams),
    { keepPreviousData: true, ...options },
  );

  return {
    ...query,
    pagination: query.data?.data?.pagination ?? {},
    data: query.data?.data?.data ?? [],
  };
};

export const useRunbook = (params = {}, options = {}) => {
  const query = useApiQuery(
    [RUNBOOKS, 'detail', params.id],
    () => firehydrantAPI.get(`/runbooks/${params.id}`),
    { enabled: !!params.id, ...options },
  );

  return {
    ...query,
    data: query.data?.data ?? {},
  };
};

export const useCreateRunbook = (options) =>
  createMutationHook((params) => firehydrantAPI.post('runbooks', params))(
    options,
  );

export const useDeleteRunbook = (options) =>
  createMutationHook((params) =>
    firehydrantAPI.delete(`runbooks/${params.id}`, params),
  )(options);

export const useUpdateRunbook = (options) =>
  createMutationHook((params) =>
    firehydrantAPI.put(`runbooks/${params.id}`, params),
  )(options);
